import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { pathgen } from 'object-path-generator';
import { IconButton, Row, Typography } from 'seagull';
import { EditLine, TrashLine } from 'seagull/icons';
import styles from './ServiceItem.module.scss';
export const ServiceItemTestIds = pathgen('ServiceItemTestIds');
const ActionIconButton = (param)=>{
    let { testId, icon, onClick } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        testId: testId,
        type: "button",
        size: "small",
        noPadding: true,
        skin: "transparent",
        onClick: onClick,
        children: icon
    });
};
const ServiceItem = (param)=>{
    let { includedService, mode, onEdit, onDelete, testId, isArchived } = param;
    function renderActionButtons() {
        switch(mode){
            case 'editAndDelete':
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ActionIconButton, {
                            testId: ServiceItemTestIds.EditButton(includedService.serviceTemplateId || ''),
                            icon: /*#__PURE__*/ _jsx(EditLine, {}),
                            onClick: ()=>onEdit(includedService)
                        }),
                        /*#__PURE__*/ _jsx(ActionIconButton, {
                            testId: ServiceItemTestIds.DeleteButton(includedService.serviceTemplateId || ''),
                            icon: /*#__PURE__*/ _jsx(TrashLine, {}),
                            onClick: ()=>onDelete(includedService)
                        })
                    ]
                });
            case 'delete':
                return /*#__PURE__*/ _jsx(ActionIconButton, {
                    testId: ServiceItemTestIds.DeleteButton(includedService.serviceTemplateId || ''),
                    icon: /*#__PURE__*/ _jsx(TrashLine, {}),
                    onClick: ()=>onDelete(includedService)
                });
            case 'readonly':
                return null;
        }
    }
    return /*#__PURE__*/ _jsxs(Row, {
        testId: testId,
        className: styles.serviceItem,
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.bullet
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        ellipsis: true,
                        variant: "paragraph1",
                        testId: ServiceItemTestIds.ServiceItemName(includedService.serviceTemplateId || ''),
                        children: "".concat(includedService.name).concat(isArchived ? ' (Archived)' : '')
                    })
                ]
            }),
            renderActionButtons()
        ]
    });
};
export default ServiceItem;
